import { clientFetch } from 'app/utils/client-fetch';
import * as types from './types';
import config from 'app/config';
import { Room } from 'app/components/shared/interfaces';

export const apiGetArcadeRooms = (arcadeId: string): Promise<{ rooms: Room[] }> =>
    clientFetch({
        url: `${config.ARCADE_API_URL}/arcades/${arcadeId}/rooms`,
        type: types.GET_ARCADE_ROOM
    });

export const apiGetArcadeRoom = arcadeRoomId => {
    return clientFetch({
        url: `${config.ARCADE_API_URL}/rooms/${arcadeRoomId}`,
        type: types.GET_ARCADE_ROOM
    });
};

export const apiPostArcadeRoom = (arcadeId, arcadeRoom) => {
    return clientFetch({
        method: 'POST',
        body: { arcadeId, ...arcadeRoom },
        url: `${config.ARCADE_API_URL}/rooms`,
        type: types.POST_ARCADE_ROOM
    });
};

export const apiPutArcadeRoom = (arcadeRoom, arcadeRoomId) => {
    return clientFetch({
        method: 'PUT',
        url: `${config.ARCADE_API_URL}/rooms/${arcadeRoomId}`,
        type: types.PUT_ARCADE_ROOM,
        body: arcadeRoom
    });
};

export const apiDeleteArcadeRoom = arcadeRoomId => {
    return clientFetch({
        method: 'DELETE',
        url: `${config.ARCADE_API_URL}/rooms/${arcadeRoomId}`,
        type: types.DELETE_ARCADE_ROOM
    });
};
